import { ReactElement } from "react";

export const childContainsKey = (child: ReactElement, keySubstring: string) =>
  typeof child.key === "string" && child.key.includes(keySubstring);
